import { render, staticRenderFns } from "./contact.vue?vue&type=template&id=fdc7a4da&"
import script from "./contact.vue?vue&type=script&lang=js&"
export * from "./contact.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {GeneralBreadcrumbs: require('/data/www/nvpa.org/nvpa/nuxt/components/general/Breadcrumbs.vue').default,CloudflareTurnstile: require('/data/www/nvpa.org/nvpa/nuxt/components/cloudflare/Turnstile.vue').default,GeneralContactCard: require('/data/www/nvpa.org/nvpa/nuxt/components/general/ContactCard.vue').default})
